// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SIOi","label":"styles_label__G_SZ8"};